<template>
  <v-app>
    <v-container>
      <v-row justify="center">
        <v-col
          cols="12"
          md="8"
        >
          <div id="content">
            <div
              class="pa-5"
              v-html="data"
            />
          </div>
        </v-col>
      </v-row>
      <v-row
        v-if="!error && data"
        justify="center"
        class="pa-5"
      >
        <v-col
          cols="8"
          md="5"
        >
          <v-form v-model="valid">
            <v-text-field
              v-model="email"
              outlined
              label="E-mail"
              :hint="text"
              persistent-hint
              :rules="[v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Неверный E-mail']"
            >
              <template v-slot:append>
                <v-btn
                  color="primary"
                  :disabled="text ||!valid"
                  class="mt-n2"
                  @click="sendemail()"
                >
                  <span class="mx-3">Отправить чек</span>
                </v-btn>
              </template>
            </v-text-field>
          </v-form>
        </v-col>
        <v-col
          cols="4"
          md="3"
          class="text-right"
        >
          <v-btn
            color="primary"
            outlined
            class="ml-5"
            @click="download()"
          >
            <v-icon class="ml-3">
              mdi-download
            </v-icon>
            <span class="mx-3">Скачать</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
  import html2canvas from 'html2canvas'
  import $ from 'jquery'
  import { jsPDF } from 'jspdf'
import { setTimeout } from 'timers'
  export default {
    name: 'Cheque',
    data: () => ({
      data: '',
      email: '',
      error: false,
      text: null,
      valid: false
    }),
    mounted: function () {
      if (this.$route.query.id) {
        this.axios.post('/api/payment/cheque', { id: this.$route.query.id })
          .then(response => {
            if (response.data.redirect) {
              window.location.href = response.data.redirect
            } else {
              this.data = response.data.data
              this.email = response.data.email
              this.error = response.data.error
            }
          })
          .catch(e => console.log(e))
      }
    },
    methods: {
      download: function () {
        var HTML_Width = $('#content').width()
        var HTML_Height = $('#content').height()
        var top_left_margin = 0
        var PDF_Width = HTML_Width + (top_left_margin * 2)
        var PDF_Height = (PDF_Width * 1.5) + (top_left_margin * 2)
        var canvas_image_width = HTML_Width
        var canvas_image_height = HTML_Height
        window.scrollTo(0, 0)
        setTimeout(function () {
          html2canvas($('#content')[0]).then(function (canvas) {
            var imgData = canvas.toDataURL('image/jpeg', 1.0)
          var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height])
          pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height)
          pdf.save('Чек по операции.pdf')
        })
        }, 100)
        /* html2canvas($('#content')[0], { allowTaint: true }).then(function (canvas) {
          canvas.getContext('2d')
          console.log(canvas.height + '  ' + canvas.width)
          var imgData = canvas.toDataURL('image/jpeg', 1.0)
          var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height])
          console.log([PDF_Width, PDF_Height])
          pdf.addImage(imgData, 'JPG',top_left_margin, top_left_margin, canvas_image_width, canvas_image_height)
          pdf.save('Чек по операции.pdf')
        }) */
        /* var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height])
        pdf.html($('#content')[0])
        pdf.save('Чек по операции.pdf') */
      },
      sendemail: function () {
        this.axios.post('/api/payment/email', { id: this.$route.query.id, email: this.email })
          .then(response => {
            this.text = 'Чек отправлен'
          })
      },
    },
  }
</script>
